import { t } from 'i18next';
import { ResourcesCard, type ResourcesCardItem } from '../../../components/resources-card';

export function CustomerGroupsResourcesCard() {
  const items: ResourcesCardItem[] = [
    {
      icon: 'inbox',
      title: t(
        'features:customer_group.components.customer_groups_resources_card.invite_customers.title',
      ),
      subtitle: t(
        'features:customer_group.components.customer_groups_resources_card.invite_customers.subtitle',
      ),
      onClick: () => window.open('https://docs.sparklayer.io/onboarding#inviting', '_blank'),
    },
    {
      icon: 'settings',
      title: t(
        'features:customer_group.components.customer_groups_resources_card.customer_setup.title',
      ),
      subtitle: t(
        'features:customer_group.components.customer_groups_resources_card.customer_setup.subtitle',
      ),
      onClick: () =>
        window.open('https://docs.sparklayer.io/customers#synchronising-customer-data', '_blank'),
    },
    {
      icon: 'payment',
      title: t(
        'features:customer_group.components.customer_groups_resources_card.payment_methods.title',
      ),
      subtitle: t(
        'features:customer_group.components.customer_groups_resources_card.payment_methods.subtitle',
      ),
      onClick: () => window.open('https://docs.sparklayer.io/customers#payment-methods', '_blank'),
    },
  ];

  return (
    <ResourcesCard
      title={t('features:customer_group.components.customer_groups_resources_card.header')}
      items={items}
    />
  );
}
